export default {"src":"/_next/static/media/delete.0a1ea7b3.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};